import classNames from 'classnames';
import { DateTimePicker, DropdownList } from 'react-widgets';
import moment from 'moment';
import styles from '../../../../../../../../../components/assets/simple-table.module.scss';
import user from '../../../../../../../../../services/user-auth';
import UserRole from '../../../../../../../../../enumerables/user-role';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faSave, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import * as React from 'react';
import { Button, Modal } from 'react-bootstrap';

const getColumnChange: any = ({ component, setOpenDrop, occasion, statusItems }: any) => {
    const isMobile = window.innerWidth <= 800;
    const today = new Date();
    return {
        id: (
            <input
                type="hidden"
                className={classNames('form-control', 'input-sm')}
                onChange={(ev) => component.handleChange(ev, 'id')}
                value={component.state['id']}
            />
        ),
        seanceDate: (
            <div style={{ minWidth: 150, maxWidth: 150 }}>
                <DateTimePicker
                    onChange={(date: any) => {
                        component.setState({ ...component.state, seanceDate: date });
                    }}
                    value={component.state['seanceDate']}
                    time={false}
                    date={true}
                    dropUp={!isMobile}
                    onToggle={(isOpen) => {
                        if (isOpen) {
                            setOpenDrop(true);
                        } else {
                            setOpenDrop(false);
                        }
                    }}
                    min={occasion?.caseNumberValidityFrom ? new Date(occasion?.caseNumberValidityFrom) : undefined}
                    max={occasion?.caseNumberValidityTo ? new Date(occasion?.caseNumberValidityTo) : undefined}
                    format={'MMM D, YYYY'}
                />
            </div>
        ),

        startTime: (
            <div style={{ minWidth: 130, maxWidth: 130 }}>
                <DateTimePicker
                    onChange={(date: any, dateStr: string | undefined) => {
                        const dateTime = dateStr ? moment(dateStr, 'h:m A').toDate() : new Date();

                        component.setState({ ...component.state, startTime: dateTime });
                    }}
                    min={new Date(today.getFullYear(), today.getMonth(), today.getDate(), 7)}
                    max={new Date(today.getFullYear(), today.getMonth(), today.getDate(), 21)}
                    dropUp={!isMobile}
                    value={component.state['startTime']}
                    time={true}
                    onToggle={(isOpen) => {
                        if (isOpen) {
                            setOpenDrop(true);
                        } else {
                            setOpenDrop(false);
                        }
                    }}
                    date={false}
                    step={15}
                    format={'LT'}
                />
            </div>
        ),
        endTime: (
            <div style={{ minWidth: 130, maxWidth: 130 }}>
                <DateTimePicker
                    onChange={(date: any, dateStr: any) => {
                        const dateTime = dateStr ? moment(dateStr, 'h:m A').toDate() : new Date();
                        component.setState({ ...component.state, endTime: dateTime });
                    }}
                    dropUp={!isMobile}
                    min={new Date(today.getFullYear(), today.getMonth(), today.getDate(), 7)}
                    max={new Date(today.getFullYear(), today.getMonth(), today.getDate(), 21)}
                    value={component.state['endTime']}
                    time={true}
                    date={false}
                    onToggle={(isOpen) => {
                        if (isOpen) {
                            setOpenDrop(true);
                        } else {
                            setOpenDrop(false);
                        }
                    }}
                    step={15}
                    format={'LT'}
                />
            </div>
        ),
        totalUnit: <div>{component.state['totalUnit']}</div>,
        totalFee: <div>{component.state['totalFee']}</div>,
        status: (
            <div className={classNames(styles.statusWrap)}>
                {!user.getRoles().includes(UserRole.ROLE_ADMIN) &&
                component.state.provider?.userProviders &&
                !component.state.provider.userProviders.length &&
                +component.state.status.value === 4 ? (
                    component.state.status.label
                ) : (
                    <DropdownList
                        data={statusItems}
                        textField="label"
                        valueField="value"
                        onChange={(item: SelectObject) => {
                            component.setState({ ...component.state, status: item });
                        }}
                        onToggle={(isOpen) => {
                            if (isOpen) {
                                setOpenDrop(true);
                            } else {
                                setOpenDrop(false);
                            }
                        }}
                        dropUp={!isMobile}
                        value={component.state.status}
                    />
                )}
            </div>
        ),

        action: (
            <div className={classNames(styles.wrapButtons)}>
                <button
                    className={classNames(styles.buttonColumn)}
                    type={'button'}
                    onClick={() => component.handleClick()}
                >
                    <FontAwesomeIcon style={{ color: 'green' }} icon={faCheckCircle} />
                </button>
                <button
                    className={classNames(styles.buttonColumn)}
                    type={'button'}
                    onClick={() => component.props.action(false)}
                >
                    <FontAwesomeIcon style={{ color: 'red' }} icon={faTimesCircle} />
                </button>
            </div>
        ),
    };
};
export default getColumnChange;
